import {BaseService} from "./base.service";

class TicketQuoterWorkerService extends BaseService {
    constructor() {
        super('api/ticket-quoter-worker');
    }
}

export const ticketQuoterWorkerService = new TicketQuoterWorkerService();
